import React from "react";

import { ChevronIcon } from "@packages/ds";

import Checkbox from "./Checkbox.styles";
import * as S from "./Th.styles";
import { SortDirections } from "./useSort";

export interface ThProps {
  children?: React.ReactNode;
  className?: string;
  width?: string;
  id?: string;
  onCheckedChanged?: () => void;
  checked?: boolean;
  onSortChanged?: () => void;
  isSortActive?: boolean;
  sortDirection?: SortDirections;
}

const chevronDirection = (
  isSortActive: ThProps["isSortActive"],
  sortDirection: ThProps["sortDirection"]
): "down" | "up" => {
  if (!isSortActive) return "down";
  if (sortDirection === "asc") return "up";
  return "down";
};

const Th = ({
  children,
  className,
  width,
  id,
  onCheckedChanged,
  checked,
  onSortChanged,
  isSortActive,
  sortDirection
}: ThProps) => (
  <S.Layout className={className} width={width}>
    {onCheckedChanged && (
      <Checkbox
        id={`th_${id}`}
        forId={`th_${id}`}
        label=""
        checked={!!checked}
        onCheckedChanged={onCheckedChanged}
      />
    )}
    <S.Action
      as={onSortChanged ? "button" : "div"}
      sortable={!!onSortChanged}
      isSortActive={isSortActive}
      onClick={onSortChanged}
    >
      {children}
      {!!onSortChanged && (
        <ChevronIcon
          aria-label="chevron-icon-table-th"
          direction={chevronDirection(isSortActive, sortDirection)}
        />
      )}
    </S.Action>
  </S.Layout>
);

export default Th;
